import { GridColumnMenu, GridColumnMenuProps } from '@mui/x-data-grid';

export function CustomColumnMenu(props: GridColumnMenuProps) {
  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuColumnsItem: null,
      }}
    />
  );
}
